import { Currency } from "../graphql/operations";

const Cookies = require("js-cookie");

export function getCurrency() {
  return (Cookies.get("currency") || "USD") as Currency;
}
